"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = exports.StyledAccordion = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const localStorage_1 = __importDefault(require("../../../hooks/localStorage"));
const theme_1 = __importDefault(require("../styles/theme"));
const _1 = require(".");
const logging_1 = require("../../../logging");
exports.StyledAccordion = styled_1.default.div `
	border-top: 1px solid ${theme_1.default.colours.neutral.light};
	padding: 0
		${(props) => props.sideMargin !== undefined
    ? `${props.sideMargin}px`
    : theme_1.default.layout.spacing.standard};
	&:last-of-type {
		border-bottom: 1px solid ${theme_1.default.colours.neutral.light};
	}
	@media only screen and (min-width: 768px) {
		padding: 0
			${(props) => props.sideMargin !== undefined
    ? `${props.sideMargin}px`
    : theme_1.default.layout.spacing.xLarge};
	}
`;
const DEFAULT_ACCORDION_OPEN = true;
const isFunctionNode = (node) => {
    if (typeof node !== 'object')
        return false;
    return typeof (node === null || node === void 0 ? void 0 : node.type) === 'function';
};
// turn an array like [header, body, header, body] into an array like [{ header, body }]
const buildAccordionTree = (children) => {
    return children.reduce((output, child, idx) => {
        if (!isFunctionNode(child)) {
            logging_1.logging.error(`Accordion children must be AccordionItem or AccordionHeader, not ${(child === null || child === void 0 ? void 0 : child.toString()) || 'unknown child type'}`);
            return output;
        }
        // "round down" odd numbers to the nearest even or zero, to pair up header and body
        const item = (output.length - (idx % 2)) / 2;
        output[item] = output[item] || { header: null, body: null };
        if (child.type === _1.AccordionItem)
            output[item].body = child;
        if (child.type === _1.AccordionHeader)
            output[item].header = child;
        return output;
    }, []);
};
const buildState = (tree, state) => {
    return tree.map((item, idx) => {
        var _a, _b, _c;
        if (state)
            return state[idx];
        if (((_a = item.body) === null || _a === void 0 ? void 0 : _a.props) && 'startCollapsed' in ((_b = item.body) === null || _b === void 0 ? void 0 : _b.props))
            return ((_c = item.body) === null || _c === void 0 ? void 0 : _c.props.startCollapsed) !== true;
        return DEFAULT_ACCORDION_OPEN;
    });
};
const render = (tree, state, update) => {
    return tree.reduce((children, item, index) => {
        const { body, header } = item;
        return [
            ...children,
            !header
                ? null
                : React.cloneElement(header, {
                    key: `item-${index}`,
                    open: !!state[index],
                    onClick: () => {
                        const next = [...state];
                        next.splice(index, 1, !state[index]);
                        update(next);
                    },
                }),
            !body
                ? null
                : React.cloneElement(body, {
                    open: !!state[index],
                    key: `item-${index + 1}`,
                }),
        ];
    }, []);
};
const Accordion = (props) => {
    // abandon collapsing and persistence in test runs
    // this functionality is tested in e2e browser tests
    if (!props.children ||
        !Array.isArray(props.children) ||
        process.env.NODE_ENV === 'test') {
        return React.createElement(exports.StyledAccordion, Object.assign({}, props), props.children);
    }
    const items = buildAccordionTree(props.children);
    if (props.persistenceId) {
        const [open, setOpen] = (0, localStorage_1.default)(props.persistenceId, () => buildState(items));
        return (React.createElement(exports.StyledAccordion, Object.assign({}, props), render(items, open, setOpen)));
    }
    else {
        const [open, setOpen] = React.useState(() => buildState(items));
        return (React.createElement(exports.StyledAccordion, Object.assign({}, props), render(items, open, setOpen)));
    }
};
exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map